import "../../../../stylesheets/bingo";
import "../../../../stylesheets/templates/bingo/template-1";
import "../../../../stylesheets/templates/bingo/template-2";
import "../../../../stylesheets/templates/bingo/template-3";
import "../../../../stylesheets/templates/bingo/template-4";
import "../../../../stylesheets/accounts/base";
import "./index";
import "./products";
import "./inscriptions";

$(document).ready(function () {
  $(document).on("change", ".bingo-ticket-pack", function (e) {
    const packId = e.currentTarget.value;
    const packName = e.currentTarget.options[e.currentTarget.selectedIndex].text;
    const $hidden = $(`.js-bingo-product-price[data-product-id="${packId}"]`);
    $('.purchase-summary .line-text').html(packName);

    const clp = $hidden.val();
    const usd = $hidden.data("usdPrice");

    ["mobile", "desktop"].forEach((device) => {
      const $sel = $(`#select-pack-${device}`);
      if ($sel.length) {
        $sel.val(packId);
      }
      const $qty = $(`#product-quantity-${device}`);
      if ($qty.length) {
        $qty.attr("data-price", clp);
        if (usd !== undefined && usd !== null) {
          $qty.attr("data-price-usd", usd);
        }
      }
    });

    const $productId = $(
      "#donator_donation_transactions_attributes_0_product_id"
    );
    if ($productId.length) {
      $productId.val(packId);
    }

    const $desktopQty = $("#product-quantity-desktop");
    if ($desktopQty.length) {
      $desktopQty.trigger("change");
    } else {
      $("#product-quantity-mobile").trigger("change");
    }
  });
});
